module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box-wrap",
    class: {
      'inline': _vm.inline
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.removeBtn) ? _c('div', {
    staticClass: "remove-btn iconfont icon-trash-alt",
    on: {
      "click": _vm.handleRemove
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "img-box",
    class: {
      'border-dashed': _vm.border === 'dashed',
      'border-none': _vm.border === 'none'
    },
    style: ({
      'width': _vm.width + 'px',
      'height': _vm.height + 'px'
    })
  }, [(_vm.imgUrl) ? _c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }) : _c('i', {
    staticClass: "iconfont",
    class: _vm.icon,
    style: ('font-size:' + _vm.width * 0.3 + 'px')
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ecc3635", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ecc3635"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/imgBox.vue
// module id = 1039
// module chunks = 30